export const emailRegex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;

export const csvEmailRegex = /^(?:[A-Za-z0-9.-]+\.[A-Za-z]{2,})*$/;

const wildcard = '.*';

export const createEmailRegex = (domains: string[]) => {
  if (!domains || domains.includes(wildcard)) {
    return new RegExp('^([^@\\s]+)@(.){2,}\\.[a-zA-Z]{2,}$');
  }

  const domainPattern = domains
    .map((domain) => domain.replace('.', '\\.'))
    .join('|');
  return new RegExp(`^([^@\\s]+)@(${domainPattern})$`, 'i');
};
